/* eslint-disable react/prop-types */
/**
 * Copyright © Scandiweb, Inc. All rights reserved.
 *
 * @category    Puma
 * @package     Puma_Tabby
 * @author      Beshoy Samuel <info@scandiweb.com>
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import TabbyQuery from 'Query/Tabby.query';
import { PriceType } from 'Type/Price.type';
import {
    calculateFinalPrice,
    roundPrice
} from 'Util/Price';
import { fetchQuery } from 'Util/Request/Query';

import TabbyPdpComponent from './TabbyPdp.component';

/** @namespace Scandipwa/Component/TabbyPdp/Container */
export class TabbyPdpContainer extends PureComponent {
    state = {
        selector: null,
        merchantCode: null,
        publicKey: null,
        source: null,
        currency: null,
        currencyRate: null,
        theme: null,
        productType: null,
        error: null,
        isLoading: true
    };

    static propTypes = {
        price: PriceType,
        order: PropTypes.number
    };

    static defaultProps = {
        price: {},
        order: 0
    };

    componentDidMount() {
        const {
            tabbyWidgetPdp: {
                script_url = '',
                selector = '',
                merchantCode = '',
                publicKey = '',
                source = '',
                currency = '',
                currencyRate = '',
                theme = '',
                productType = '',
                error = ''
            } = {}
        } = this.props;

        if (script_url === '') {
            fetchQuery(TabbyQuery.getWidgetPdp()).then(
                /** @namespace Scandipwa/Component/TabbyPdp/Container/TabbyPdpContainer/componentDidMount/then/catch/fetchQuery/then */
                ({ getTabbyWidgetPdp }) => {
                    const {
                        script_url,
                        selector,
                        merchantCode,
                        publicKey,
                        source,
                        currency,
                        currencyRate,
                        theme,
                        productType,
                        error
                    } = getTabbyWidgetPdp;

                    if (script_url === '') {
                        this.setState({ isLoading: false, error: true });
                    } else {
                        const script = document.createElement('script');
                        script.type = 'text/javascript';
                        script.text = `(function(a,b,c,d){
                                a='${script_url}';
                                b=document;c='script';d=b.createElement(c);d.src=a;
                                d.type='text/java'+c;d.async=true;
                                d.id='tabbypdpwidget';
                                a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a)
                            })()`;

                        document.head.insertBefore(script, document.head.childNodes[0]);

                        this.setState({
                            selector,
                            merchantCode,
                            publicKey,
                            source,
                            currency,
                            currencyRate,
                            theme,
                            productType,
                            error,
                            isLoading: false
                        });
                    }
                }
            ).catch(
                /** @namespace Scandipwa/Component/TabbyPdp/Container/TabbyPdpContainer/componentDidMount/then/catch */
                () => {
                    this.setState({ isLoading: false, error: true });
                }
            );
        } else {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.text = `(function(a,b,c,d){
                    a='${script_url}';
                    b=document;c='script';d=b.createElement(c);d.src=a;
                    d.type='text/java'+c;d.async=true;
                    d.id='tabbypdpwidget';
                    a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a)
                })()`;

            document.head.insertBefore(script, document.head.childNodes[0]);

            this.setState({
                selector,
                merchantCode,
                publicKey,
                source,
                currency,
                currencyRate,
                theme,
                productType,
                error,
                isLoading: false
            });
        }
    }

    containerProps = () => {
        const { price, order } = this.props;
        if (!price) {
            return {};
        }

        const {
            price: {
                minimum_price: {
                    discount: {
                        percent_off: discountPercentage
                    } = {},
                    final_price: {
                        value: minimalPriceValue
                    } = {},
                    regular_price: {
                        value: regularPriceValue
                    } = {}
                } = {}
            } = {}
        } = this.props;

        if (!minimalPriceValue || !regularPriceValue) {
            return {};
        }

        const finalPrice = calculateFinalPrice(discountPercentage, minimalPriceValue, regularPriceValue);
        const formatedPrice = roundPrice(finalPrice);

        return {
            formatedPrice,
            order,
            ...this.state
        };
    };

    render() {
        return (
            <TabbyPdpComponent
              { ...this.containerProps() }
            />
        );
    }
}

export default TabbyPdpContainer;
